import { render } from "./GridLoaders.vue?vue&type=template&id=0a24c261"
import script from "./GridLoaders.vue?vue&type=script&lang=js"
export * from "./GridLoaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__